import { Link, useNavigate } from "react-router-dom";
import { Badges, H3, Image, P } from "../../AbstractElements";
import { dynamicImage } from "../../service";
import { TableColumn } from "react-data-table-component";
import { OrganizationListTableDataColumnType } from "../../types/organization/OrganizationTypes";
import { MoreVertical } from "react-feather";
import {
  Button,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";
import { useState } from "react";
import BlockModal from "../../component/modal/BlockModal";
import CommonModal from "../../component/modal/common/CommonModal";
import ResetForm from "../../component/modal/ResetPassword";
import GeneralSettingsSection from "../../component/organization/create-organization/GeneralSettingsSection";
import { Formik, Form } from "formik";

type ProductListTableProductNameProps = {
  image?: string;
  name?: string;
};

export const productListTableData = [
  {
    id: 1,
    image: "dashboard-8/linnk_logo.png",
    name: "Linnk Group",
    industry: "Information Technology & Services",
    country: "United States",
    city: "New York",
    timezone: "UTC-5",
    currency: "USD",
    entity: 120,
    users: 1450,
    status: "Active",
    contactPerson: "John Doe",
    email: "john@linnk.com",
    mobileNumber: "+1 555-0100",
    address: " 29 Wellington Street, Leeds, LS1 4DL",
    accountType: "Free",
    pageLimit: "10",
    expireyDate: "16/07/2025",
    distributor: "Alpha Distributors",
    franchise: "Sunrise Mart",
    GoogleKey: "AI-123456789",
    androidKey: "L-1234567890",
    androidURL: "https://play.google.com/details?id",
    iosKey: "I-12345690",
    iosURL: "https://apps.apple.com/id1567890",
    authority: "Enterprise",
    language: "English",
    dateFormat: "dd/mm/yyyy",
    languages: ["English"],
  },
  {
    id: 2,
    image: "dashboard-8/eduspark.png",
    name: "EduSpark",
    industry: "Education",
    country: "India",
    city: "Bangalore",
    timezone: "UTC+05:30",
    currency: "INR",
    entity: 60,
    users: 700,
    status: "Active",
    contactPerson: "Priya Shah",
    email: "priya@eduspark.in",
    mobileNumber: "+91 98765 43210",
    address: "MG Road, Bangalore",
    accountType: "Free",
    pageLimit: "10",
    expireyDate: "16/07/2025",
    distributor: "Alpha Distributors",
    franchise: "Sunrise Mart",
    androidKey: "L-123456789",
    androidURL: "https://play.google.com/details?id=com.linnk.employee",
    iosKey: "I-123456789",
    iosURL: "https://apps.apple.com/id1234567890",
    GoogleKey: "A-1236789",
    authority: "Education",
    language: "English",
    dateFormat: "dd/mm/yyyy",
    languages: ["English"],
  },
  {
    id: 3,
    image: "dashboard-8/bluefin.png",
    name: "BlueFin Capital",
    industry: "Financial Services",
    country: "Germany",
    city: "Frankfurt",
    timezone: "UTC+1",
    currency: "EUR",
    entity: 110,
    users: 980,
    status: "Active",
    contactPerson: "Hans Müller",
    email: "hans@bluefin.de",
    mobileNumber: "+49 170 1234567",
    address: "Main Tower, Frankfurt",
    pageLimit: "10",
    expireyDate: "16/07/2025",
    distributor: "Alpha Distributors",
    franchise: "Sunrise Mart",
    GoogleKey: "A-123456789",
    androidKey: "L-1234789",
    androidURL: "https://play.google.com/details?id",
    iosKey: "I-123456789",
    iosURL: "https://apps.apple.com/app/id",
    authority: "Education",
    language: "English",
    dateFormat: "dd/mm/yyyy",
    languages: ["English", "German"],
  },
];

export const ProductListTableProductName: React.FC<
  ProductListTableProductNameProps
> = ({ image, name }) => {
  return (
    <div className="product-names my-2">
      <div className="light-product-box">
        <Image
          className="img-fluid"
          src={dynamicImage(image)}
          alt="organization"
          style={{ width: "49px", height: "49px" }}
        />
      </div>
      <P>{name}</P>
    </div>
  );
};

const ProductListTableStatus: React.FC<{ status?: string }> = ({ status }) => {
  return (
    <Badges
      color="transparent"
      className={`badge-light-${
        status === "Inactive" ? "secondary" : "primary"
      }`}
    >
      {status}
    </Badges>
  );
};

// Actions for Organization List Table
const OrgListTableAction: React.FC<{
  row: OrganizationListTableDataColumnType;
}> = ({ row }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [modalOne, setModalOne] = useState<boolean>(false);
  const [selectedOrg, setSelectedOrg] =
    useState<OrganizationListTableDataColumnType | null>(null);
  const [modalType, setModalType] = useState("Block");
  const [staticModal, setStaticModal] = useState(false);
  const [showGeneralSettings, setShowGeneralSettings] = useState(false);


  const staticModalToggle = () => {
    setStaticModal(!staticModal);
    setSelectedOrg(row);
  };
  const modalOneToggle = () => setModalOne(!modalOne);

  const openModal = (type: "Block" | "Unblock" | "Delete") => {
    setModalType(type);
    setModalOne(true);
    setSelectedOrg(row);
  };

  const generalSettingsToggle = () => {
    setShowGeneralSettings(!showGeneralSettings);
    setSelectedOrg(row);
  };

  const onHandleApiKeys = () => {
    navigate(`${process.env.PUBLIC_URL}/users/organization-admin/api-keys`);
  };

  

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="span" className="cursor-pointer">
        <MoreVertical size={18} />
      </DropdownToggle>
      <DropdownMenu container="body">
        <Link to={`${process.env.PUBLIC_URL}/organization/view/${row.id}`}>
          <DropdownItem>{t("View")}</DropdownItem>
        </Link>
        <Link to={`${process.env.PUBLIC_URL}/organization/edit/${row.id}`}>
          <DropdownItem>{t("Edit")}</DropdownItem>
        </Link>
        {row.status === "Active" ? (
          <DropdownItem onClick={() => openModal("Block")}>
            {t("Block")}
          </DropdownItem>
        ) : (
          <DropdownItem onClick={() => openModal("Unblock")}>
            {t("Unblock")}
          </DropdownItem>
        )}

        <DropdownItem onClick={() => openModal("Delete")}>
          {t("Delete")}
        </DropdownItem>
        <DropdownItem onClick={staticModalToggle}>
          {t("Reset Password")}
        </DropdownItem>
        <DropdownItem onClick={generalSettingsToggle}>
          {t("Settings")}
        </DropdownItem>
        <DropdownItem onClick={onHandleApiKeys}>
          {t("APIKeys")}
        </DropdownItem>
      </DropdownMenu>
      {selectedOrg && (
        <BlockModal
          orgData={selectedOrg}
          modalOne={modalOne}
          modalOneToggle={modalOneToggle}
          modalType={modalType}
        />
      )}
      <CommonModal
        backdrop="static"
        modalBodyClassName="social-profile text-start"
        isOpen={staticModal}
        toggle={staticModalToggle}
      >
        <div className="modal-toggle-wrapper">
          <H3 className="modal-header justify-content-center border-0">
            {t("ResetPassword")}
          </H3>

          <ResetForm staticModalToggle={staticModalToggle} data={selectedOrg} />
        </div>
      </CommonModal>

      <CommonModal
        backdrop="static"
        modalBodyClassName="text-start text-start custom-centered-modal"
        isOpen={showGeneralSettings}
        size="xl"
        toggle={generalSettingsToggle}
      >
        <div className="modal-toggle-wrapper">
          <H3 className="modal-header justify-content-center border-0">
            {t("GeneralSettings")}
          </H3>
          {selectedOrg && (
            <Formik
              initialValues={selectedOrg}
              onSubmit={(values) => {
                // handle save here (API call, etc.)
                console.log("Updated values:", values);
                generalSettingsToggle(); // close modal after save
              }}
              enableReinitialize
            >
              <Form>
                <GeneralSettingsSection isEdit={true} />
              <div className="text-end mt-3">
               <Button color="secondary" className="me-2">{t("Cancel")}</Button>
               <Button  color="primary" type="submit" >{t("Save")}</Button>
               </div>
              </Form>
            </Formik>
          )}
        </div>
      </CommonModal>
    </UncontrolledDropdown>
  );
};

export const productListTableDataColumn = (
  t: TFunction
): TableColumn<OrganizationListTableDataColumnType>[] => [
  {
    name: t("OrganizationName"),
    cell: (row) => (
      <ProductListTableProductName image={row.image} name={row.name} />
    ),
    sortable: true,
    grow: 2,
  },
  {
    name: t("OrganizationIndustry"),
    selector: (row) => `${row.industry}`,
    sortable: true,
  },
  {
    name: t("OrganizationCountry"),
    selector: (row) => `${row.country}`,
    sortable: true,
  },
  {
    name: t("OrganizationCity"),
    selector: (row) => `${row.city}`,
    sortable: true,
  },
  {
    name: t("OrganizationTimezone"),
    selector: (row) => `${row.timezone}`,
    sortable: true,
  },
  {
    name: t("Entities"),
    selector: (row) => `${row.entity}`,
    sortable: true,
  },
  {
    name: t("Users"),
    selector: (row) => `${row.users}`,
    sortable: true,
  },
  {
    name: t("Status"),
    cell: (row) => <ProductListTableStatus status={row.status} />,
  },

  {
    name: t("Actions"),
    cell: (row) => <OrgListTableAction row={row} />,
    center: true,
    minWidth: "50px",
  },
];

export const filtersData = [
  {
    name: "Choose Industry",
    options: [
      "EcoGreen Solutions",
      "Healthcare",
      "Environmental",
      "Finance",
      "Manufacturing",
    ],
  },
  {
    name: "Choose Country",
    options: [
  "United States",
  "United Kingdom",
  "Canada",
  "Germany",
  "France",
  "Australia",
  "Japan",
  "China",
  "India",
  "Brazil",
  "Russia",
  "Italy",
  "Spain",
  "Mexico",
  "South Korea",
  "Netherlands",
  "Sweden",
  "Switzerland",
  "Norway",
  "Denmark",
  "Finland",
  "Belgium",
  "Austria",
  "Portugal",
  "Greece",
  "Ireland",
  "Poland",
  "Czech Republic",
  "Hungary",
  "Turkey",
  "Egypt",
  "South Africa",
  "Nigeria",
  "Kenya",
  "Argentina",
  "Chile",
  "Colombia",
  "Peru",
  "New Zealand",
  "Singapore",
  "Malaysia",
  "Thailand",
  "Vietnam",
  "Philippines",
  "Indonesia",
  "Pakistan",
  "Bangladesh",
  "Saudi Arabia",
  "United Arab Emirates",
  "Israel"
],
  },
  {
    name: "Choose City",
    options: ["New York", "London", "Toronto", "Berlin", "Paris"],
  },
  {
    name: "Status",
    options: ["Active", "Inactive"],
  },
  {
    name: "Timezone",
    options: ["UTC-5", "UTC+0", "UTC-4", "UTC+1", "UTC+2"],
  },
];
